import { render, staticRenderFns } from "./SepomexImporter.vue?vue&type=template&id=129a7a22&scoped=true&"
import script from "./SepomexImporter.vue?vue&type=script&lang=js&"
export * from "./SepomexImporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129a7a22",
  null
  
)

export default component.exports